<template>
  <a :href="data.url" rel="noopener noreferrer" target="_blank" style="display:block;height:100%">
    <v-col class="d-flex flex-column align-center">
      <v-icon v-if="data.icon" :icon="data.icon"></v-icon>
      <v-icon v-else icon="mdi-link-variant"></v-icon>
    </v-col>

    <v-col style="word-break: break-word" class="d-flex flex-column align-center">
      <span>{{ data.name }}</span>
    </v-col>
  </a>
</template>

<script>
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
  },
  name: "hyperLinkWidget",
  data() {
    return {};
  },
  created() { },
  methods: {},
};
</script>
